import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  tableContainer: {
    display: "flex",
    gap: 16,
    flexDirection: "column",
    alignItems: "flex-start",
    boxSizing: "border-box",
    backgroundColor: "rgba(28, 30, 31)",
    minHeight: 600,
    width: "100%",
    borderRadius: 24,
    border: "1px solid #000000",
    padding: "24px 60px",
    overflowX: "auto",

    [theme.breakpoints.down("lg")]: {
      padding: "16px 32px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: 16,
    },
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    textAlign: "left",
    padding: "10px",
    color: "#aaa",
    fontFamily: "Philosopher",
    fontWeight: 900,

    "& div": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: 8,
    },

    "& img": {
      width: 16,
      height: 16,
      borderRadius: 4,
    },

    "& button": {
      padding: "0px 4px",
      minWidth: 24,
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
  },
  td: {
    padding: "16px",
    borderBottom: "1px solid #333",
    textTransform: "none",
    minWidth: 60,
    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#fff",

      [theme.breakpoints.down("sm")]: {
        fontSize: 14,
      },
    },

    [theme.breakpoints.down("sm")]: {
      padding: 12,
    },
  },

  tableFooter: {
    fontFamily: "Philosopher",
    fontWeight: 900,
    color: "#fff",

    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
  },

  tableFooterItem: {
    padding: "16px",
    display: "flex",
    gap: 16,

    textTransform: "none",
    minWidth: 60,

    [theme.breakpoints.down("sm")]: {
      padding: 12,
    },
  },
  input: {
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgb(23, 24, 25)",
    color: "#888",
    border: "1px solid black",
    borderRadius: "16px",
    padding: "8px 16px",
    fontFamily: "Philosopher",
    fontWeight: 900,
  },
  buttonBuy: {
    backgroundColor: "rgb(43, 84, 28)",
    color: "#fff",
    border: "none",
    borderRadius: "16px",
    padding: "4px 24px",
    cursor: "pointer",
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",

    "&:disabled": {
      backgroundColor: "rgb(23, 24, 25)",
      cursor: "not-allowed",
    },
  },
  buttonSell: {
    backgroundColor: "rgb(148, 49, 34)",
    color: "#fff",
    border: "none",
    borderRadius: "16px",
    padding: "4px 24px",
    cursor: "pointer",
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",

    "&:disabled": {
      backgroundColor: "rgb(23, 24, 25)",
      cursor: "not-allowed",
    },
  },
}));

export default styles;
